import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Alert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'
import IndividualCouponsTab from './components/IndividualCouponsTab'
import AutomaticCouponsTab from './components/AutomaticCouponsTab'
import AmbassadorsTab from './components/AmbassadorsTab'
import TenantCouponTab from './components/TenantCouponTab'
import { useCurrentUser } from '../../shared/hooks/useCurrentUser'

const BASE_TABS = [
  { label: 'Cupons Individuais', Component: IndividualCouponsTab },
  { label: 'Campanhas Automáticas', Component: AutomaticCouponsTab },
  { label: 'Embaixadores', Component: AmbassadorsTab },
]

const TENANT_TAB = { label: 'Vínculo com Tenant', Component: TenantCouponTab }

function DiscountCouponsPage() {
  const { allowedToApplyCouponToATenant } = useCurrentUser()
  const location = useLocation()
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState(0)

  const successMessage = location.state?.successMessage

  const TABS = allowedToApplyCouponToATenant ? [...BASE_TABS, TENANT_TAB] : BASE_TABS
  const ActiveTabComponent = TABS[activeTab]?.Component ?? TABS[0].Component

  function handleSnackbarClose() {
    navigate(location.pathname, { replace: true, state: null })
  }

  return (
    <Box>
      <Typography variant="h5" component="h2" gutterBottom>
        Cupons de desconto
      </Typography>

      <Tabs
        value={activeTab}
        onChange={(_, newValue) => setActiveTab(newValue)}
        sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
      >
        {TABS.map(({ label }) => (
          <Tab key={label} label={label} />
        ))}
      </Tabs>

      <ActiveTabComponent />

      <Snackbar
        open={!!successMessage}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          {successMessage}
        </Alert>
      </Snackbar>
    </Box>
  )
}

export default DiscountCouponsPage
